import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=64672aad&scoped=true&"
import script from "./Media.vue?vue&type=script&lang=js&"
export * from "./Media.vue?vue&type=script&lang=js&"
import style0 from "./Media.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Media.vue?vue&type=style&index=1&id=64672aad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64672aad",
  null
  
)

export default component.exports